import { render } from "./MultiRangeSlider.vue?vue&type=template&id=3653d544"
import script from "./MultiRangeSlider.vue?vue&type=script&lang=js"
export * from "./MultiRangeSlider.vue?vue&type=script&lang=js"

import "./MultiRangeSlider.vue?vue&type=style&index=0&id=3653d544&lang=css"

import exportComponent from "/home/runner/work/maskingruppen-new/maskingruppen-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__